import React, { useContext } from "react";
import { connect } from "react-redux";
import { Context } from "@components/useContext/context";
import {
  CardWrapper,
  HeaderSection,
  HeaderNumber,
  HeaderQuote,
  Divider,
  ContentBox,
  MainText,
  ContentDivider,
  SubText
} from "./styles";

interface LieCardProps {
  is_visible?: boolean;
  actions?: any;
  lieNumber?: string;
  lieQuote?: string;
  mainText?: string;
  subText?: string;
}

const LieCard = (props: LieCardProps) => {
  const { is_visible = true, lieNumber, lieQuote, mainText, subText } = props;
  return (
    <CardWrapper>
      <HeaderSection>
        <HeaderNumber>{lieNumber}</HeaderNumber>
        <HeaderQuote
          dangerouslySetInnerHTML={{
            __html:
              lieQuote
          }}
        />
      </HeaderSection>
      <Divider />
      <ContentBox>
        <MainText
          dangerouslySetInnerHTML={{
            __html:
              mainText
          }}
        />
        {subText ? <><ContentDivider />
          <SubText
            dangerouslySetInnerHTML={{
              __html:
                subText
            }}
          /></> : null}
      </ContentBox>
    </CardWrapper>
  );
};

export default LieCard;
